export const externalContactLink =
  'https://calendar.app.google/tjMkkWkv5cuoa5kg6';
